// extracted by mini-css-extract-plugin
module.exports = {"button":"SubmitButton_button__1zbH8","slide-in-right":"SubmitButton_slide-in-right__2c_86","slide-out-right":"SubmitButton_slide-out-right__1Fk8d"};